import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import PoliciesPage from './pages/PoliciesPage';
import CalendarPage from './pages/CalendarPage';
import PolicyDetailPage from './pages/PolicyDetailPage';
import ReportsPage from './pages/ReportsPage';
import CommissionsPage from './pages/CommissionsPage';
import UsersPage from './pages/UsersPage';
import ClaimsPage from './pages/ClaimsPage';
import TicketsPage from './pages/TicketsPage';
import CeoPage from './pages/CeoPage';
import QuotesPage from './pages/QuotesPage';
import DifusionPage from './pages/DifusionPage';
import DebtsPage from './pages/DebtsPage';
import RenewalsPage from './pages/RenewalsPage';
import ImportsPage from './pages/ImportsPage';
import LicensesPage from './pages/LicensesPage';
import ChatPage from './pages/ChatPage';
import AgentPage from './pages/AgentPage';
import BotPage from './pages/BotPage';
import InsightsPage from './pages/InsightsPage';
import ActivityPage from './pages/ActivityPage';
import EmployeesPage from './pages/EmployeesPage';
import FinancesPage from './pages/FinancesPage';
import Toast from './components/layout/Toast';

function PrivateRoute({ children, adminOnly = false }) {
  const { currentUser } = useApp();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (adminOnly && currentUser.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { currentUser } = useApp();

  // El equipo de Vida, Salud y Ahorro no usa este panel: su pantalla la sirve
  // el backend en /vida y su usuario no tiene permiso para ninguna API de la
  // oficina. Si cae acá (por ejemplo recién logueado), lo mandamos para allá.
  if (currentUser?.role === 'vsa') {
    window.location.replace('/vida');
    return null;
  }
  // Los aliados comerciales (automotoras del convenio) tienen su tablero en
  // /socios, servido por el backend. Ven solo lo suyo; el CRM no es para ellos.
  if (currentUser?.role === 'socio') {
    window.location.replace('/socios');
    return null;
  }

  return (
    <>
      <Toast />
      <Routes>
        <Route path="/login" element={currentUser ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<DashboardPage />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="clients/:id" element={<ClientDetailPage />} />
          <Route path="policies" element={<PoliciesPage />} />
          <Route path="policies/:id" element={<PolicyDetailPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="claims" element={<ClaimsPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="quotes" element={<QuotesPage />} />
          <Route path="difusion" element={<PrivateRoute adminOnly><DifusionPage /></PrivateRoute>} />
          <Route path="debts" element={<DebtsPage />} />
          <Route path="renewals" element={<RenewalsPage />} />
          <Route path="imports" element={<ImportsPage />} />
          <Route path="licenses" element={<LicensesPage />} />
          <Route path="chat" element={<ChatPage />} />
          <Route path="agent" element={<AgentPage />} />
          <Route path="insights" element={<InsightsPage />} />
          <Route path="ceo" element={<PrivateRoute adminOnly><CeoPage /></PrivateRoute>} />
          <Route path="bot" element={<PrivateRoute adminOnly><BotPage /></PrivateRoute>} />
          <Route path="employees" element={<PrivateRoute adminOnly><EmployeesPage /></PrivateRoute>} />
          <Route path="finances" element={<PrivateRoute adminOnly><FinancesPage /></PrivateRoute>} />
          <Route path="commissions" element={<PrivateRoute adminOnly><CommissionsPage /></PrivateRoute>} />
          <Route path="activity" element={<PrivateRoute adminOnly><ActivityPage /></PrivateRoute>} />
          <Route path="users" element={<PrivateRoute adminOnly><UsersPage /></PrivateRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}
